import { Input } from "antd";
import { useThrottle } from "../../../../uikit/hooks/useThrottle";
import { FocusEventHandler, KeyboardEventHandler, Ref, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import func from "@uikit/func";
import style from "./TextNode.module.scss";
import cls from "classnames";
import { NO_WHEEL } from "../constants";
import classNames from "classnames";
import { useStartNode } from "../../../../custom-hooks/useNodePreview";
import { TextNodeBloc, TextProps } from "./TextNodeBloc";
import { useSignal } from "@preact/signals-react";

export const Text: React.FC<TextProps> = props => {
  const enableBlurType = ["text", "inputTextarea"];
  const isChildNode = props.parentNodeId !== "";
  const isScrollBottom = useSignal(false);
  const inputBoxRef = useRef<null | HTMLDivElement>(null);
  const bloc = new TextNodeBloc(props);

  const imagicaStudioTutorial = useSelector((state: any) => state.fot.imagicaStudioTutorial);
  const disableAddPreview = useSelector((state: any) => state.fot.disableAddPreview);
  const { isStartNode, isStartNodeAdded } = useStartNode(props.id);

  useThrottle(
    () => {
      if (bloc.textValue.value.length > 260 && inputBoxRef.current && props.showStopGenerateBtn === true) {
        // 滚动到底部
        const distance = inputBoxRef.current.scrollHeight - inputBoxRef.current.clientHeight;
        inputBoxRef.current.scrollTop = distance;
      }
    },
    100,
    [bloc.textValue.value, props.showStopGenerateBtn]
  );

  useEffect(() => {
    if (props.showStopGenerateBtn === false) {
      setTimeout(() => {
        // 滚动到顶部
        if (inputBoxRef.current) {
          inputBoxRef.current.scrollTop = 0;
        }
      }, 200);
    }
  }, [props.showStopGenerateBtn]);

  const handleNodeScroll = () => {
    const nodeRef = inputBoxRef.current;
    if (nodeRef) {
      const contentScrollTop = nodeRef.scrollTop; // 滚动条距离顶部
      const clientHeight = nodeRef.clientHeight; // 可视区域
      const scrollHeight = nodeRef.scrollHeight; // 滚动条内容的总高度
      if (contentScrollTop + clientHeight >= scrollHeight) {
        isScrollBottom.value = true;
      } else {
        // 需要保留，滚动条向上回滚时才会生效
        isScrollBottom.value = false;
      }
    }
  };
  const textNodeClassName = cls(
    style["custom-node"],
    style["design-text"],

    (props.isLongPress || props.checkNodeArr.includes(props.id)) && `nopan ${NO_WHEEL}`,
    style["guide-textnode-disable"],
    props.enableFeedback && style["target"],
    !disableAddPreview && isStartNode && !isStartNodeAdded && !props?.isStaticApp ? style.reservedButtonHeight : ""
  );

  // 在blueprint中高度由内容决定
  const reSizeStyle = bloc.isInBlueprint.value ? {} : bloc.reSizeStyle();

  return (
    <div className={style.textNodeScrollZone}>
      {/* textnode底部的blur effect */}
      {!isScrollBottom.value &&
      !func.isEmpty(bloc.textValue.value) &&
      enableBlurType.includes(props.displayType) &&
      props.type !== "customGroup" &&
      !isChildNode ? (
        <span className={style.showNodeBlur}></span>
      ) : null}
      <div className={textNodeClassName} ref={inputBoxRef} style={reSizeStyle} onScroll={() => handleNodeScroll()}>
        <div className={style["text-content"]}>
          {/* 双击选中Input */}
          <div
            className={`${style["input-mask"]} ${props.isLongPress ? style["hidden-mask"] : ""} ${
              !disableAddPreview ? style["previewing"] : ""
            } ${bloc.isInBlueprint.value ? style["input-in-blueprint"] : ""}`}
          >
            {!props.isLongPress && (func.isEmpty(bloc.textValue.value) || typeof bloc.textValue.value === "string") ? (
              <p
                className={`${style["alternate-text"]} ${
                  func.isEmpty(bloc.textValue.value) ? style["place-color"] : ""
                }`}
              >
                {(typeof bloc.textValue.value === "string" && bloc.textValue.value) || bloc.placeHolder.value}
              </p>
            ) : null}
          </div>

          {/* 如果只是在blueprint里展示 此时不可以编辑 */}
          {!bloc.isInBlueprint.value && (
            <div
              className={classNames(style["text-textArea"], {
                nodrag: props.isLongPress,
                [style["show-text-textArea"]]: props.isLongPress,
                [style["max-textarea-height"]]: !props.isResized,
              })}
            >
              <Input.TextArea
                className={`${style.textarea} ${!props.isLongPress ? "hidden-input" : ""}`}
                readOnly={imagicaStudioTutorial.showGuide && !props.guideNodeEditable}
                value={props.textAreaValue[0].results[0].content}
                ref={props.inputRef}
                onPressEnter={props.onTextAreaEnter}
                onChange={e =>
                  props.setTextAreaValueWithParam({
                    content: e.target.value,
                  })
                }
                onBlur={e => props.onTextAreaBlur(e)}
                onFocus={props.onTextAreaFocus}
                placeholder={bloc.placeHolder.value}
                autoSize={{ minRows: 4 }}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
